import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'

import { PRACTICE_DEVELOPMENT, PROGRESS_VIEW_ITEMS } from '../configs'

interface IPracticeDevelopmentProgressValues {
  progressItems: string[]
  currentProgress: string
  followUp: string
}

const PROGRESS_ITEM_KEYS = [...PROGRESS_VIEW_ITEMS]
  .sort((left, right) => left.order - right.order)
  .map((item) => item.key)

export const getIsPracticeDevelopment = (
  keyObjective?: string | null,
  keyObjectives: IKeyObjective[] = [],
  fallback = false
): boolean => {
  const selectedKeyObjective = keyObjectives.find((item) => item.key === keyObjective)

  return (
    keyObjective === PRACTICE_DEVELOPMENT ||
    selectedKeyObjective?.parent === PRACTICE_DEVELOPMENT ||
    (!selectedKeyObjective && fallback)
  )
}

export const getPracticeDevelopmentProgressValues = (
  currentProgress?: string | null
): IPracticeDevelopmentProgressValues => {
  const selectedItems = new Set(
    (currentProgress ?? '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
  )
  const progressItems = PROGRESS_ITEM_KEYS.filter((key) => selectedItems.has(key))
  const followUpItems = PROGRESS_ITEM_KEYS.filter((key) => !selectedItems.has(key))

  return {
    progressItems,
    currentProgress: progressItems.join(','),
    followUp: followUpItems.join(','),
  }
}
